import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PartnersSection from '../../components/oem-partnership/PartnerSection';
import UpdatesSection from '../../components/feature/UpdatesSection';

export default function OEMPartnership() {



  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section
        className="relative text-white overflow-hidden  h-96 flex items-end lg:pb-[70px] pb-0 lg:pl-[140px] pl-[0px] items-center lg:items-end lg:justify-start justify-center text-white"
        style={{ backgroundColor: '#022843' }}
      >
        <div className="relative z-10 px-6 text-center lg:text-left">
          <h1 className="text-3xl lg:text-[64px] font-medium mb-[10px] text-white">
          OEM Partnerships
          </h1>
          <p className="text-lg text-[#FFFFFFB2] ">
          We partner with world-leading manufacturers to deliver proven equipment and technologies
          </p>
        </div>
        <div className="absolute right-[-250px] top-0 bottom-[-250px] flex items-center overflow-hidden">
          <img
            src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1770041854/d008fc7d2b6cf42543aa422914cfe5ba54a0828e_pqqboi.png"
            alt=""
            width={846}
            height={517}
            className="h-[517px] w-[846px] object-cover  opacity-10"
            style={{ opacity: 1 }}
          />
        </div>
      </section>

      <PartnersSection />

      <UpdatesSection bgColor="bg-[#F9F9F9]" />
      <Footer />
    </div>
  );
}